import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { RootStoreState } from '..';
import * as reportActions from './actions';
import * as loginSelectors from '../login-store/login.selector';
import { ReportService } from '@app/shared/services/report/report.service';

@Injectable()
export class ReportStoreEffects {
  user;
  reportObject = this.store$.select('Report');

  constructor(private reportService: ReportService, private actions$: Actions, private store: Store, private store$: Store<RootStoreState.State>) {
    this.store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((result) => {
      if (result) {
        this.user = result;
      }
    });
  }

  getSharedVault$: Observable<any> = createEffect(() =>
  
  this.actions$.pipe(
    ofType<reportActions.GetReportRequestAction>(reportActions.ActionTypes.GET_REPORT_REQUEST),
    switchMap((action: any) => {
      return this.reportService.getReport().pipe(
        map((data) => {
          return new reportActions.GetReportSuccessAction(data);
        }),
        catchError((error) => {
          return of( new reportActions.GetReportRequestFailureAction(error));
        })
      );
    })
  )
  );
}
